import {
  animate,
  group,
  query,
  sequence,
  style,
  transition,
  trigger,
} from '@angular/animations';

export const leftOutletTransitions = [
  trigger('leftOutletTransitions', [
    transition(
      'project => *, owners => wrap-up, owners => review, wrap-up => review',
      [
        group([
          query(
            ':enter',
            sequence([
              style({ opacity: 0, transform: 'translateX(38%)' }),
              animate(
                '400ms ease',
                style({ opacity: 1, transform: 'translateX(0)' })
              ),
            ]),
            { optional: true }
          ),
          query(
            ':leave',
            style({ opacity: 0, position: 'absolute', left: '-100%' }),
            { optional: true }
          ),
        ]),
      ]
    ),
    transition(
      'review => *, wrap-up => owners, wrap-up => project, owners => project',
      [
        group([
          query(
            ':enter',
            sequence([
              style({ opacity: 0, transform: 'translateX(-38%)' }),
              animate(
                '400ms ease',
                style({ opacity: 1, transform: 'translateX(0)' })
              ),
            ]),
            { optional: true }
          ),
          query(
            ':leave',
            style({ opacity: 0, position: 'absolute', left: '-100%' }),
            { optional: true }
          ),
        ]),
      ]
    ),
  ]),
];
